<script>
    import moment from 'moment';
    import 'moment/locale/es';
    import 'moment/locale/en-au';
    import { sgettext } from '../../../i18n';

    export let data;
    let style_status;
    if (data.context !== "") {
        switch (data.context) {
            case sgettext("$$REVIEW_ENDORSED$$"):
            case sgettext("$$CONTROL_APPROVED$$"):
            case sgettext("$$STRATEGY_APPROVED$$"):
            case sgettext("$$ACTIVITY_APPROVED$$"):
                style_status = "approved";
                break;
            case sgettext("$$REVIEW_REJECTED$$"):
            case sgettext("$$CONTROL_REJECTED$$"):
            case sgettext("$$STRATEGY_REJECTED$$"):
            case sgettext("$$ACTIVITY_REJECTED$$"):
                style_status = "rejected";
                break;
            case sgettext("$$REQUEST_APPROVAL_1$$"):
                style_status = "request";
                break;
            case sgettext("$$REQUEST_WITHDRAWN$$"):
                style_status = "withdrawn";
                break;
            default:
                break;
        }
    }
    moment.locale(Cookies.get("django_language"))
</script>

<div class="row">
  <div class="col" data-testid="username"><i class="fa fa-user" /> {data.username}</div>
  <div class="float-right" data-testid="created-date">{moment(data.created_date).fromNow()}</div>
</div>
<div class="row">
  <div class="col" data-testid="comment-text">
    {@html data.comment}
  </div>
  <div class="context" data-testid="comment-context" style-status={style_status}>{data.context}</div>
</div>

<style>
  .context {
    float: right;
    font-size: 0.7rem;
    color: white;
    border-radius: 1rem;
    padding: 0.3em 0.6em 0.3em;
    overflow-y: auto;
    margin-bottom: 1.5em;
    max-height: 25px;
  }
  .context[style-status='approved'] {
    background-color: #2f7d32;
  }
  .context[style-status='rejected'] {
    background-color: #d22f30;
  }
  .context[style-status='request'] {
    background-color: #0487d0;
  }
  .context[style-status='withdrawn'] {
    background-color: #ffa500;
    color: black;
  }
</style>
